import { useNavigate } from "react-router-dom";
import { useCallback } from "react";
import eventBus from "@/utilities/eventBus";
import { getCurrentCustomer, clearTimezoneCache } from "@/utilities/common";

export interface AccountSwitchOptions {
  aid: number;
  cid: number;
  url: string;
  accounts?: any[];
  suppressEvents?: boolean;
}

export const useAccountSwitch = () => {
  const navigate = useNavigate();

  const switchAccount = useCallback(
    async (options: AccountSwitchOptions) => {
      const { aid, cid, url, accounts, suppressEvents = false } = options;

      try {
        // 清除时区缓存
        clearTimezoneCache();

        // 暂时禁用事件监听器以避免冲突
        if (!suppressEvents) {
          eventBus.off("accountChange");
        }

        // 执行路由跳转
        navigate(url, { replace: true });

        // 延迟发射数据更新事件
        if (!suppressEvents) {
          setTimeout(() => {
            const currentCustomerInfo = getCurrentCustomer(Number(cid))[0];
            const currentAccountInfo = accounts?.find(
              (acc: any) => acc.accountId === aid
            );

            // 发射账户切换事件，标记为用户主动操作
            eventBus.emit("accountChange", {
              aid,
              cid,
              customer: currentCustomerInfo,
              account: currentAccountInfo,
              isUserAction: true,
            });
          }, 200);
        }

        return { success: true };
      } catch (error) {
        console.error("Account switch failed:", error);
        return { success: false, error };
      }
    },
    [navigate]
  );

  return { switchAccount };
};
